import { render, staticRenderFns } from "./compensation-pdf.vue?vue&type=template&id=63f7813a&scoped=true"
import script from "./compensation-pdf.vue?vue&type=script&lang=js"
export * from "./compensation-pdf.vue?vue&type=script&lang=js"
import style0 from "./compensation-pdf.vue?vue&type=style&index=0&id=63f7813a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f7813a",
  null
  
)

export default component.exports